import React, {Component} from 'react'
import { connect } from 'react-redux'

// Actions
import { getCustomer, getCustomerContacts } from '../../../actions/customers'

// import components
import Header from '../../../shared/components/Header'
import LeftMenuContent from '../../../shared/components/Menus/LeftMenu/Content'
import CreateUser from '../../../shared/components/CreateUser'

// Elements
import Button from '../../../shared/elements/button'
import SideMenu from '../../../shared/elements/sideMenu'
import SideMenuItem from '../../../shared/elements/sideMenuItem'
import SideMenuCustomItem from '../../../shared/elements/sideMenuCustomItem'
import Check from '../../../shared/elements/check'

// Views
import View from './View'

// Utils
import { hasSubscriptionPermission } from '../../../utils/auth'
import { translation } from '../../../utils/helpers'
import CloseButton from '../../../shared/elements/closeButton'

class Contacts extends Component {

  constructor (props) {
    super(props)
    this.state = {
      view: 'list',
      includeNonVerified: false,
      activeItem: {},
      contacts: [],
      customerName: '',
      isPartnerShopCustomer: false,
      isOwnedByShop: false,
      canAddContacts: false
    }
    this.headerButtonsRight = this.headerButtonsRight.bind(this)
    this.onSave = this.onSave.bind(this)
    this.onViewFail = this.onViewFail.bind(this)
    this.onSelectItem = this.onSelectItem.bind(this)
    this.createView = this.createView.bind(this)
  }

  componentDidMount () {
    this.getCustomer(this.props)
    this.getContacts()
    if (typeof this.props.params.contactID !== 'undefined') {
      this.setState({
        view: 'item',
        activeItem: {
          UserId: Number(this.props.params.contactID),
          CustomerId: this.props.params.customerID !== 'undefined' ? this.props.params.customerID : 0
        }
      })
    }
  }

  getCustomer (props) {
    if (typeof props.params.customerID !== 'undefined') {
      props.getCustomer(props.params.customerID).then((res) => {
        this.setState({
          customerName: res.data.CompanyName,
          isPartnerShopCustomer: res.data.IsPartnerShopCustomer,
          isOwnedByShop: res.data.IsOwnedByShop,
          canAddContacts: res.data.CanAddContacts
        })
      }, (err) => {
        if (err.response.status === 401) {
          this.props.router.replace('/orders')
        }
      })
    }
  }

  getContacts () {
    return this.props.getCustomerContacts(this.props.params.customerID).then((res) => {
      this.setState({
        contacts: res.data
      })
      if (res.data.length === 0) {
        this.changeView('create')
      }
    }, () => {
      console.log('err')
    })
  }

  changeView (view) {
    let activeItem = this.state.activeItem
    if (view === 'create') {
      activeItem = {}
    }
    this.setState({
      view: view,
      activeItem: activeItem
    })
    this.props.router.replace('/customers/' + this.props.params.customerID + '/contacts')
  }

  headerButtonsRight () {
    if (this.state.view === 'create') return null
    if (!hasSubscriptionPermission(this.props.auth, 10, 0) && this.state.contacts.length < 2) return null
    if (this.state.isPartnerShopCustomer) return null
    return (
      <div>
        {this.state.canAddContacts && <Button size='m' spacing={0} labelText={translation(1797)} ariaText={translation('2079')} onClick={this.changeView.bind(this, 'create')} />}
      </div>
    )
  }

  createView () {
    // If view is create
    if (this.state.view === 'create') {
      const onAdd = () => {
        this.refs.create.getWrappedInstance().createUser()
      }
      return [
        <SideMenuCustomItem key='0' isFixed>
          <Button onClick={onAdd} labelText={translation('1208')} />
        </SideMenuCustomItem>,
        <SideMenuCustomItem key='1' isFixed>
          <Button style='secondary' onClick={this.changeView.bind(this, 'list')} labelText={translation('570')} />
        </SideMenuCustomItem>
      ]
    }

    return [
      <div key='confirmedfilter' className='filter'>
        <SideMenuCustomItem isFixed>
          <Check
            name='NonVerified'
            checked={this.state.includeNonVerified}
            onChange={() => { this.setState({includeNonVerified: !this.state.includeNonVerified}) }}
            labelText={translation('16320')}
            spacing={0}
          />
        </SideMenuCustomItem>
      </div>,
      ...this.state.contacts.map(e => {
        return (
          <SideMenuItem
            label={e.Name}
            onClick={() => this.onSelectItem(e)}
            selected={e.UserId === this.state.activeItem.UserId}
            inactive={!e.Active}
            confirmed={e.Confirmed}
            key={e.UserId}
          />
        )
      })
    ]
  }

  onSave (data, type) {
    let contacts = [...this.state.contacts]
    let activeItem
    if (type === 'create') {
      contacts.push({
        Name: data.Name,
        UserId: data.UserId,
        Active: data.Active,
        Email: data.Email,
        Confirmed: false
      })
      type = 'item'
      activeItem = {
        UserId: data.UserId,
        Confirmed: false
      }
    } else {
      contacts.map((val, key) => {
        if (val.UserId === data.UserId) {
          val.Name = data.Name
          val.Active = data.Active
        }
      })
      type = 'item'
      if (data.Confirmed) {
        activeItem = {
          UserId: data.UserId,
          Confirmed: true
        }
      } else {
        activeItem = {
          UserId: data.UserId,
          Email: data.Email,
          Name: data.Name,
          Confirmed: data.Confirmed,
          CustomerId: data.CustomerId
        }
      }
    }
    this.setState({
      contacts: contacts,
      view: type,
      activeItem: activeItem
    })
    // Toastr
    // window.toastr.success(translation('13462'), translation('13424'))
  }

  onViewFail () {
    this.setState({
      view: 'list',
      activeItem: {}
    })
    this.props.router.replace('/customers/' + this.props.params.customerID + '/contacts')
  }

  renderView () {
    switch (this.state.view) {
      case 'list':
        return <div />
      case 'create':
        return <CreateUser isContact ref='create' title={translation('16339')} customerID={this.props.params.customerID} user={undefined} onSuccess={res => this.onSave(res, 'create')} />
      case 'item':
        if (this.state.activeItem.Confirmed === false) return <CreateUser isContact user={this.state.activeItem} title={translation('16339')} onSuccess={res => this.onSave(res, 'item')} />
        return <View router={this.props.router} ref='view' item={this.state.activeItem} onSave={this.onSave} getContacts={this.getContacts} customerID={this.props.params.customerID} isOwnedByShop={this.state.isOwnedByShop} onError={this.onViewFail} />
    }
  }

  onSelectItem (item) {
    this.setState({
      view: 'item',
      activeItem: item
    })
    this.props.router.replace('/customers/' + this.props.params.customerID + '/contacts')
  }

  render () {
    let headerButtonsGoBack
    headerButtonsGoBack = (router, t) => {
      const goBack = () => {
        let isCustomer = this.props.auth.user.UserType === 4
        if (isCustomer) {
          this.props.router.goBack()
        }
        this.props.router.replace({
          pathname: '/customers',
          query: {
            customerId: this.props.params.customerID
          }
        })
      }
      return (
        <CloseButton ariaText={t('2060')} onClick={goBack} />
      )
    }

    let isCustomer = this.props.auth.user.UserType === 4
    const customFilter = (item, showInactive) => {
      // Include any items not confirmed if using this filter
      if (this.state.includeNonVerified && !item.confirmed) {
        return true
      }
      if (showInactive) {
        // Exclude unconfirmed
        return item.confirmed
      }
      return !item.inactive
    }

    return (
      <div className='customers__screen'>
        <Header router={this.props.router} pageTitleExtra={!isCustomer ? this.state.customerName : null} renderRight={this.headerButtonsRight} showBack headerButtonsGoBack={headerButtonsGoBack} />
        <SideMenu showFilter={this.state.view !== 'create'} hideInactiveCheck={this.state.view === 'create'} customFilter={customFilter}>
          {this.createView()}
        </SideMenu>
        <LeftMenuContent className='customers__screen--inner'>
          {this.renderView()}
        </LeftMenuContent>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, { getCustomerContacts, getCustomer })(Contacts)



// WEBPACK FOOTER //
// ./src/app/pages/Customers/Contacts/index.js